module.exports = __webpack_public_path__ + "static/media/Save.489fda3b.png";